import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../js/charSequenceJs.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from './StringBuilderJs.mjs';
import {
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  Char__compareTo_impl_ypi4mbdrkik40uwhqc as Char__compareTo_impl_ypi4mb,
} from '../Char.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
import { isLettere1qnx5bysxbd as isLetter } from './charJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.rt_1 = new (BytesHexFormat())(2147483647, 2147483647, '  ', '', '', '');
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.st_1 = new (NumberHexFormat())('', '', false, 1);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var BytesHexFormatClass;
function BytesHexFormat() {
  if (BytesHexFormatClass === VOID) {
    class $ {
      constructor(bytesPerLine, bytesPerGroup, groupSeparator, byteSeparator, bytePrefix, byteSuffix) {
        Companion_getInstance();
        this.tt_1 = bytesPerLine;
        this.ut_1 = bytesPerGroup;
        this.vt_1 = groupSeparator;
        this.wt_1 = byteSeparator;
        this.xt_1 = bytePrefix;
        this.yt_1 = byteSuffix;
        this.zt_1 = (this.tt_1 === 2147483647 && this.ut_1 === 2147483647);
        var tmp = this;
        var tmp_0;
        var tmp_1;
        // Inline function 'kotlin.text.isEmpty' call
        var this_0 = this.xt_1;
        if (charSequenceLength(this_0) === 0) {
          // Inline function 'kotlin.text.isEmpty' call
          var this_1 = this.yt_1;
          tmp_1 = charSequenceLength(this_1) === 0;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = this.wt_1.length <= 1;
        } else {
          tmp_0 = false;
        }
        tmp.au_1 = tmp_0;
        this.bu_1 = isCaseSensitive(this.vt_1) || isCaseSensitive(this.wt_1) || isCaseSensitive(this.xt_1) || isCaseSensitive(this.yt_1);
      }
      toString() {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().d1();
        // Inline function 'kotlin.text.appendLine' call
        this_0.wb('BytesHexFormat(').xb(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        this.cu(this_0, '    ').xb(_Char___init__impl__6a9atx(10));
        this_0.wb(')');
        return this_0.toString();
      }
      cu(sb, indent) {
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        sb.wb(indent).wb('bytesPerLine = ').yg(this.tt_1).wb(',').xb(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        sb.wb(indent).wb('bytesPerGroup = ').yg(this.ut_1).wb(',').xb(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        sb.wb(indent).wb('groupSeparator = "').wb(this.vt_1).wb('",').xb(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        sb.wb(indent).wb('byteSeparator = "').wb(this.wt_1).wb('",').xb(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        sb.wb(indent).wb('bytePrefix = "').wb(this.xt_1).wb('",').xb(_Char___init__impl__6a9atx(10));
        sb.wb(indent).wb('byteSuffix = "').wb(this.yt_1).wb('"');
        return sb;
      }
    }
    initMetadataForClass($, 'BytesHexFormat');
    BytesHexFormatClass = $;
  }
  return BytesHexFormatClass;
}
var NumberHexFormatClass;
function NumberHexFormat() {
  if (NumberHexFormatClass === VOID) {
    class $ {
      constructor(prefix, suffix, removeLeadingZeros, minLength) {
        Companion_getInstance_0();
        this.kt_1 = prefix;
        this.lt_1 = suffix;
        this.mt_1 = removeLeadingZeros;
        this.nt_1 = minLength;
        var tmp = this;
        var tmp_0;
        // Inline function 'kotlin.text.isEmpty' call
        var this_0 = this.kt_1;
        if (charSequenceLength(this_0) === 0) {
          // Inline function 'kotlin.text.isEmpty' call
          var this_1 = this.lt_1;
          tmp_0 = charSequenceLength(this_1) === 0;
        } else {
          tmp_0 = false;
        }
        tmp.ot_1 = tmp_0;
        this.pt_1 = (this.ot_1 && this.nt_1 === 1);
        this.qt_1 = isCaseSensitive(this.kt_1) || isCaseSensitive(this.lt_1);
      }
      toString() {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().d1();
        // Inline function 'kotlin.text.appendLine' call
        this_0.wb('NumberHexFormat(').xb(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        this.cu(this_0, '    ').xb(_Char___init__impl__6a9atx(10));
        this_0.wb(')');
        return this_0.toString();
      }
      cu(sb, indent) {
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        sb.wb(indent).wb('prefix = "').wb(this.kt_1).wb('",').xb(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        sb.wb(indent).wb('suffix = "').wb(this.lt_1).wb('",').xb(_Char___init__impl__6a9atx(10));
        var tmp0 = sb.wb(indent).wb('removeLeadingZeros = ').xg(this.mt_1);
        // Inline function 'kotlin.text.appendLine' call
        var value = _Char___init__impl__6a9atx(44);
        // Inline function 'kotlin.text.appendLine' call
        tmp0.xb(value).xb(_Char___init__impl__6a9atx(10));
        sb.wb(indent).wb('minLength = ').yg(this.nt_1);
        return sb;
      }
    }
    initMetadataForClass($, 'NumberHexFormat');
    NumberHexFormatClass = $;
  }
  return NumberHexFormatClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        this.ft_1 = new (HexFormat())(false, Companion_getInstance().rt_1, Companion_getInstance_0().st_1);
        this.gt_1 = new (HexFormat())(true, Companion_getInstance().rt_1, Companion_getInstance_0().st_1);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new (Companion_1())();
  return Companion_instance_1;
}
var HexFormatClass;
function HexFormat() {
  if (HexFormatClass === VOID) {
    class $ {
      constructor(upperCase, bytes, number) {
        Companion_getInstance_1();
        this.ht_1 = upperCase;
        this.it_1 = bytes;
        this.jt_1 = number;
      }
      toString() {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().d1();
        // Inline function 'kotlin.text.appendLine' call
        this_0.wb('HexFormat(').xb(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        this_0.wb('    upperCase = ').xg(this.ht_1).wb(',').xb(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        this_0.wb('    bytes = BytesHexFormat(').xb(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        this.it_1.cu(this_0, '        ').xb(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        this_0.wb('    ),').xb(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        this_0.wb('    number = NumberHexFormat(').xb(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        this.jt_1.cu(this_0, '        ').xb(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        this_0.wb('    )').xb(_Char___init__impl__6a9atx(10));
        this_0.wb(')');
        return this_0.toString();
      }
    }
    initMetadataForClass($, 'HexFormat');
    HexFormatClass = $;
  }
  return HexFormatClass;
}
function isCaseSensitive(_this__u8e3s4) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.text.any' call
    var inductionVariable = 0;
    while (inductionVariable < charSequenceLength(_this__u8e3s4)) {
      var element = charSequenceGet(_this__u8e3s4, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      if (Char__compareTo_impl_ypi4mb(element, _Char___init__impl__6a9atx(128)) >= 0 || isLetter(element)) {
        tmp$ret$1 = true;
        break $l$block;
      }
    }
    tmp$ret$1 = false;
  }
  return tmp$ret$1;
}
//region block: exports
export {
  Companion_getInstance_1 as Companion_getInstance2zux61tby3qbv,
};
//endregion

//# sourceMappingURL=HexFormat.mjs.map
